const pickStudentIdsByRole = (students, role) =>
  Object.entries(students).reduce((carry, [id, { roleName }]) => (roleName === role ? [...carry, id] : carry), []);

export default pickStudentIdsByRole;
